<script lang="ts" setup>
withDefaults(
  defineProps<{
    specialities: any[]
    otherCount?: number | null
  }>(),
  { otherCount: null }
)
</script>

<template>
  <div>
    <strong
      v-for="(x, index) in specialities"
      :key="x.id"
      class="w-min text-main-aluminum font-normal"
      :title="x.attributes.name"
    >
      <span class="inline" itemprop="jobTitle">
        {{ x.attributes.name.substring(0, 30) }}{{ x.attributes.name.length > 30 ? '...' : '' }}
      </span>

      <span v-if="index + 1 !== specialities.length" class="inline pr-1">,</span>

      <span
        v-if="otherCount && index + 1 === specialities.length"
        class="inline text-main-aluminum text-sm"
      >&nbsp;(+{{ otherCount }})</span>
    </strong>
  </div>
</template>
